import { render, staticRenderFns } from "./FundsFilesListTable.vue?vue&type=template&id=fda571fe&"
import script from "./FundsFilesListTable.vue?vue&type=script&lang=js&"
export * from "./FundsFilesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports